// constants.js
export const distr_all = [
    "Голосіївський", 
    "Дарницький", 
    "Деснянський", 
    "Дніпровський", 
    "Оболонський", 
    "Печерський", 
    "Подільський", 
    "Святошинський", 
    "Солом’янський", 
    "Шевченківський"
];

export const schema = [
    {h: "#", f: "number"},
    {h: "Район", f: "district"},
    {h: "Номер ЗДО", f: "kgnumber", btitle: true},
    {h: "Дітей, разом", f:"all", b: true},
    {h: "Кияни", f: "kyivreg", b: true},
    {h: "Картка", f: "kyivcard", b: true},
    {h: "Не кияни", f: "outkyiv", b: true},
    {h: "Пільгові категорії", f: "benefits", b: true},
    {h: "Діти 6-ти річного віку", f: "sixall", b: true},
    {h: "мають сплачувати БФН", f: "topaid", b: true}
];

export const HISTORY = 'history';